import $ from "jquery";
import { useState } from "react";
import ResultsPage from "./ResultsPage";
import styles from "./YoutubeLink.module.css";
import youtube_icon from "./Icons/youtube.png";
import YoutubeInstructions from "./MinorCompnents/YoutubeInstructions";

const YoutubeLink = () => {

    const [videoLength, setVideoLength] = useState({'minutes' : 0, 'seconds' : 0});
    const [rangeSelectionActive, setRangeSelectionActive] = useState(false);
    const [videoLink, setVideoLink] = useState("");
    const [results, setResults] = useState(false);
    const [rangeStart, setRangeStart] = useState(0);
    const [rangeEnd, setRangeEnd] = useState(0);
    const [resultArray, setResultArray] = useState([]);
    const [loading, setLoading] = useState(false);

    function isValidYouTubeLink(url) {
        const pattern = /^https:\/\/youtu\.be\/[\w-]{11}\?si=[\w-]+$/;
        return pattern.test(url);
    }
    function handleLink() {
        const link = document.getElementById("link").value;
        if(link === '') {
            document.getElementById("emptyError").style.display = "flex";
            document.getElementById("emptyError").innerText = "This field cannot be empty!";
            return false;
        }

        if(!isValidYouTubeLink(link)) {
            document.getElementById("emptyError").style.display = "flex";
            document.getElementById("emptyError").innerText = "Enter valid youtube video link!";
            return false;
        }

        setLoading(true);
        setVideoLink(link);
        $.ajax({
            url : "https://truthcreds.onrender.com/getLength/",
            type : 'POST',
            contentType: "application/json",
            data : JSON.stringify({
                link : link,
            }),
            success: function(data) {
                console.log(data);
                const totalSeconds = data['length'];
                const minutes = Math.floor(totalSeconds / 60);
                const seconds = Math.floor(totalSeconds % 60);
                console.log(minutes);
                console.log(seconds);
                setVideoLength({'minutes' : minutes, 'seconds' : seconds})
                setRangeSelectionActive(true);
                setLoading(false);
            },
            error: function(xhr, status, error) {
                console.log(error);
                setLoading(false);
            }
        })
    }

    function checkLimits() {
        const startMins = parseInt(document.getElementById("startMinutes").value);
        const startSecs = parseInt(document.getElementById("startSeconds").value);
        const endMins = parseInt(document.getElementById("endMinutes").value);
        const endSecs = parseInt(document.getElementById("endSeconds").value);


        if(startMins > endMins) {
            document.getElementById("startMinutes").value = 0;
            document.getElementById("startSeconds").value = 0;
            document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
            return false;
        }

        else if(endMins > videoLength['minutes']) {
            document.getElementById("endMinutes").value = 0;
            document.getElementById("endSeconds").value = 0;
            document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
            return false;
        }

        else if(startMins === endMins) {
            if(startSecs >= endSecs) {
                document.getElementById("startSeconds").value = 0;
                document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
                return false;
            }
        }

        if(startMins === videoLength['minutes']) {
            if(startSecs > videoLength['seconds']) {
                document.getElementById("startSeconds").value = 0;
                document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
                return false;
            }
        }

        if(endMins === videoLength['minutes']) {
            if(endSecs > videoLength['seconds']) {
                document.getElementById("endSeconds").value = 0;
                document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
                return false;
            }
        }

        if(startSecs > 60 || endSecs > 60) {
            document.getElementById("endSeconds").value = 0;
            document.getElementById("startSeconds").value = 0;
            document.getElementById("limitExceeded").innerText = "Please Enter Valid Values!";
            return false;
        }

        return true;
    }

    function minutesToSeconds() {
        const startMins = parseInt(document.getElementById("startMinutes").value);
        const startSecs = parseInt(document.getElementById("startSeconds").value);
        const endMins = parseInt(document.getElementById("endMinutes").value);
        const endSecs = parseInt(document.getElementById("endSeconds").value);
        const start = startMins * 60 + startSecs;
        const end = endMins * 60 + endSecs;
        return {'start': start, 'end' : end}
    }

    function sendToVerify() {
        if(checkLimits()) {
            setLoading(true);
            const rangeOfVideo = minutesToSeconds();
            setRangeStart(rangeOfVideo['start']);
            setRangeEnd(rangeOfVideo['end']);
            $.ajax({
                url : "https://truthcreds.onrender.com/youtubeLink/",
                type : 'POST',
                contentType: "application/json",
                data : JSON.stringify({
                    link : videoLink,
                    start : rangeOfVideo['start'],
                    end : rangeOfVideo['end'],
                }),
                success: function(data) {
                    console.log(data['claims']);
                    setResultArray(data['claims']);
                    //resultArray = data['claims']
                    setResults(true);
                    setLoading(false);
                    //document.getElementById("loading").innerText = "Results";
                },
                error: function(xhr, status, error) {
                    console.log(error);
                }
            })
        }
        else {
            console.log("Error");
        }
    }

    const lengthBar = ( 
        <div className = {styles.lengthPanel}> 
            <h1 className = {styles.lengthText}>Length of video is <u>{videoLength['minutes']} minutes and {videoLength['seconds']} seconds</u>.</h1>
            <h1 className = {styles.lengthText}>Choose the part of video to verify.</h1>
            <div className = {styles.timerPanel}>
                <div className = {styles.timerSubPanel}>
                    <label className = {styles.timerLabel}>From</label>
                    <div className = {styles.timeBoxPanel}>
                        <input className = {styles.timeBox} type = "number" id = "startMinutes" min = '0' max = {videoLength['minutes']} placeholder="Minutes" defaultValue={0}/>
                        <label>Minutes</label>
                        <input className = {styles.timeBox} type="number" id = "startSeconds" min = '0' placeholder="Seconds" defaultValue={0}/>
                        <label>Seconds</label>
                    </div>
                </div>
                <div className = {styles.timerSubPanel}>
                    <label className = {styles.timerLabel}>To</label>
                    <div className = {styles.timeBoxPanel}>
                        <input className = {styles.timeBox} type = "number" id = "endMinutes" min = '0' max = {videoLength['minutes']} placeholder="Minutes" defaultValue={0}/>
                        <label>Minutes</label>
                        <input className = {styles.timeBox} type="number" id = "endSeconds" min = '0' placeholder="Seconds" defaultValue={0}/>
                        <label>Seconds</label>
                    </div>
                    
                </div>
            </div>
            <h2 className = {styles.limitExceeded} id = "limitExceeded">{null}</h2>
            <button className = {styles.button} onClick = {sendToVerify}>Send to Verify</button>
        </div>
    )

    if(loading) {
        return (
            <div div className = {styles.body}>
                <div className = {styles.loader}></div>
                <h3 className = {styles.waiting}>Thank you for waiting! This may take a while...</h3>
            </div>
        )
    }

    if(results === true) {
        return (
            <div>
                <ResultsPage resultArray = {resultArray}/>
            </div>
        )
    }
    return (
        <div className = {styles.body}>
            <div style = {{"display" : "flex", "flexDirection" : "row", "alignItems" : "center", "justifyContent" : "center"}}>
                <img className = {styles.youtubeIcon} src = {youtube_icon} alt = "youtube"/>
                <h1 className = {styles.title}>Youtube Link</h1>
            </div>
            {rangeSelectionActive === true
                ?   lengthBar 
                :   <div className = {styles.input_block}>
                        <input className = {styles.input_box} type = "text" placeholder = "Insert Youtube Video Link" id = "link"/>
                        <h3 id = "emptyError" className = {styles.errorMsg} style = {{"display" : "none", "margin" : 0}}>This field cannot be empty!</h3>
                        <button className = {styles.button} onClick = {handleLink}>SUBMIT</button>
                        <YoutubeInstructions />
                    </div>
            }
        </div>
        
    )
}

export default YoutubeLink;